/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState, useEffect } from 'react'
import { LeftOutlined, RightOutlined } from '@ant-design/icons'
import {
  Center,
  City,
  defaultCoordinates,
  SetState,
} from '../../../types/AddressesGroup'
import CentersList from './CentersList'

interface PaginationProps {
  itemsPerPage: number
  centersInList: Center[] | []
  isCorporation: boolean
  isTopCfe: boolean
  setSelectedCity: SetState<City | undefined>
  centers: Center[]
  mapRef: any
  setCurrentPage: SetState<number>
  currentPage: number
  selectedCity: City | undefined
  defaultCoordinates: defaultCoordinates
  isBe: boolean
  hostname: string
}

const Pagination: React.FC<PaginationProps> = ({
  itemsPerPage,
  centersInList,
  isCorporation,
  isTopCfe,
  setSelectedCity,
  centers,
  mapRef,
  setCurrentPage,
  currentPage,
  selectedCity,
  defaultCoordinates,
  isBe,
  hostname,
}: PaginationProps) => {
  const [centersToShow, setCentersToShow] = useState<Center[] | []>([])
  const [scroll, setScroll] = useState(false)
  const [maxPages, setMaxPages] = useState(
    Math.ceil(centersInList.length / itemsPerPage)
  )
  const startIndex = currentPage * itemsPerPage - itemsPerPage
  const endIndex = startIndex + itemsPerPage

  const goToNextPage = () => {
    setCurrentPage(currentPage + 1)
    setCentersToShow(centersInList.slice(startIndex, endIndex))
    setScroll(true)
  }

  const goToPreviousPage = () => {
    setCurrentPage(currentPage - 1)
    setCentersToShow(centersInList.slice(startIndex, endIndex))
    setScroll(true)
  }

  useEffect(() => {
    if (centersInList) {
      setCentersToShow(centersInList.slice(startIndex, endIndex))
    } else {
      setCentersToShow(centers.slice(startIndex, endIndex))
    }
    setMaxPages(Math.ceil(centersInList.length / itemsPerPage))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [centersInList, isTopCfe, currentPage])

  useEffect(() => {
    if (scroll) {
      window.scrollTo({ behavior: 'smooth', top: 267 })
      setScroll(false)
    }
  }, [scroll])

  return (
    <>
      <CentersList
        centersToShow={centersToShow}
        setSelectedCity={setSelectedCity}
        isCorporation={isCorporation}
        mapRef={mapRef}
        centersUnPaginated={centersInList}
        selectedCity={selectedCity}
        defaultCoordinates={defaultCoordinates}
        isBe={isBe}
        hostname={hostname}
      />
      {centersInList.length > 10 && (
        <div className="is-flex is-justify-content-center has-text-heading is-size-10">
          <button
            className="neutral-button mr-2"
            onClick={goToPreviousPage}
            disabled={currentPage === 1}
          >
            <LeftOutlined />
          </button>
          <span>
            {currentPage} sur {maxPages}
          </span>
          <button
            className="neutral-button ml-2"
            onClick={goToNextPage}
            disabled={currentPage === maxPages}
          >
            <RightOutlined />
          </button>
        </div>
      )}
    </>
  )
}

export default Pagination
